import { Component, OnInit } from '@angular/core';
import { Company } from '../../../models/Company.model';
import { CompaniesService } from '../../../services/companies.service';
import { DropDownList } from '../../../models/DropDownList.model';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { HashtrackService } from '../../../services/hashTrack.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { CompanySearch } from '../../../models/CompanySearch.model';
import { ExternalReferenceFinancial } from '../../../models/ExternalReference.model';

@Component({
  selector: 'app-company-match',
  templateUrl: './company-match.component.html',
  styleUrls: ['./company-match.component.css']
})
export class CompanyMatchComponent implements OnInit {

  companiesFinancial: Company[] = new Array<Company>();
  companySelected: Company = null;
  commonHelper: CommonHelper = new CommonHelper();
  dropDownCompaniesFinancial: DropDownList[] = new Array<DropDownList>();
  dropDownListCompanies: DropDownList[] = new Array<DropDownList>();
  selectedCompaniesItems: DropDownList[] = new Array<DropDownList>();
  dropDownCompaniesSettings = {};
  loading: boolean;


  selecteds: string[];


  constructor(
    private companiesService: CompaniesService,
    private hashtrackService: HashtrackService,
    public toastr: ToastsManager) {
  }

  async loadCompaniesFinancial() {
    let companySearch = new CompanySearch();
    companySearch.onlyActives = true;
    companySearch.limit = 999999;
    companySearch.onlyCustomer = true;
    this.companiesFinancial = await this.companiesService.searchCompanies(companySearch, '_id,name,externalReference');
  }

  async ngOnInit() {
    this.loading = true;
    var customersHT = await this.hashtrackService.getAllCustomers();
    await this.loadCompaniesFinancial();
    this.dropDownCompaniesFinancial = this.commonHelper.getDropDownListItems(this.companiesFinancial, "_id", "name");
    this.dropDownListCompanies = this.commonHelper.getDropDownListItems(customersHT, "_id", "name");
    this.dropDownCompaniesSettings = this.commonHelper.getDropDownSettings(true, 'Selecione um ou mais clientes', false, 'Marcar todas os clientes', 'Desmarcar todas os clientes', true,null, '');
    this.loading = false;
  }

  async matchCompanies() {

    if (this.companySelected == null) {
      this.toastr.warning("Selecione um o cliente!");
      return;
    }

    let companyToUpdate = await this.companiesService.getById(this.companySelected[0].id);

    if (this.selectedCompaniesItems.length > 0) {
      companyToUpdate.externalReference = new ExternalReferenceFinancial();
      companyToUpdate.externalReference._id = this.selectedCompaniesItems[0].id;
      companyToUpdate.externalReference.name = this.selectedCompaniesItems[0].itemName;
    } else
      companyToUpdate.externalReference = null;

    await this.companiesService.edit(companyToUpdate);
    await this.loadCompaniesFinancial();
    this.companySelected = null;
    this.selectedCompaniesItems = new Array<DropDownList>();
    this.toastr.success("Match realizado com sucesso!");
  }

  onCompanySelect(dropDownList: DropDownList) {
    this.selectedCompaniesItems = new Array<DropDownList>();

    let companyFinancial = this.companiesFinancial.find(x => x._id == dropDownList.id);

    if (companyFinancial.externalReference) {
      let id = companyFinancial.externalReference._id;
      let ddl = new DropDownList();
      ddl.id = id;
      ddl.itemName = this.dropDownListCompanies.find(x => x.id == id).itemName;
      this.selectedCompaniesItems.push(ddl);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/companies/company-match/company-match.component.ts